import { cn } from "@/lib/utils";
import { formatPercentChange } from "@/lib/intelligenceFormat";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

type Props = {
	percent: number | null;
	trend?: "up" | "down" | "flat" | null;
	className?: string;
};

export function IntelligenceVariance({ percent, trend, className }: Props) {
	const display = formatPercentChange(percent);
	const Icon =
		trend === "up" ? ArrowUpRight : trend === "down" ? ArrowDownRight : Minus;

	return (
		<span
			className={cn(
				"inline-flex items-center gap-0.5 text-xs font-medium tabular-nums",
				trend === "up" && "text-emerald-700",
				trend === "down" && "text-rose-700",
				(!trend || trend === "flat") && "text-muted-foreground",
				className
			)}
		>
			<Icon className="h-3.5 w-3.5" />
			{display}
		</span>
	);
}
